import {
  setupI18n
} from 'util/locale';
import { fdsChartsI18nSetup } from '@tcc/fds-charts';
import moment from 'moment';

const initLocales = async () => {
  await setupI18n();
  await fdsChartsI18nSetup();
  // CFVWEB-2800 Add trailing period to Ukrainian abbreviated months
  const ukLocaleData = moment.localeData('uk');
  const shortUkMonths = ukLocaleData.monthsShort();
  moment.updateLocale('uk', {
    monthsShort: shortUkMonths.map(month => {
      if (month[month.length - 1] === '.') {
        return month;
      }
      return `${month}.`;
    })
  });
};

export default initLocales;
